export default __webpack_public_path__ + "static/media/57.32124306.gif";